import { Action, combineReducers } from 'redux';

import { homeReducer } from '../../home/reducers/HomeReducer';
import { AppState } from '../state/AppState';
import { alertListInfoReducer } from './AlertListInfoReducer';
import { availableActionsForEntityReducer } from './AvailableActionsForEntityReducer';
import { breadcrumbsReducer } from './BreadcrumbsReducer';
import { contentExplorerReducer } from './contentExplorer/ContentExplorerReducer';
import { spaceInfoReducer } from './contentExplorer/SpaceInfoReducer';
import { displaySettingsReducer } from './DisplaySettingsReducer';
import { layoutTypeReducer } from './LayoutTypeReducer';
import { navigationReducer } from './NavigationReducer';
import { orderReducer } from './OrderReducer';
import { rootAdminUiStateReducer } from './RootAdminUiStateReducer';
import { sessionReducer } from './SessionReducer';
import { sitesReducer } from './SitesReducer';
import { userSettingsReducer } from './UserSettingsReducer';

export const appReducer: (
  previousState: AppState,
  action: Action
) => AppState = combineReducers<AppState>({
  alertListInfo: alertListInfoReducer,
  availableActionsForEntities: availableActionsForEntityReducer,
  breadcrumbs: breadcrumbsReducer,
  contentExplorer: contentExplorerReducer,
  displaySettings: displaySettingsReducer,
  order: orderReducer,
  session: sessionReducer,
  userSettings: userSettingsReducer,
  spaceInfo: spaceInfoReducer,
  navigationState: navigationReducer,
  sites: sitesReducer,
  home: homeReducer,
  layoutType: layoutTypeReducer,
  rootAdminUiState: rootAdminUiStateReducer,
});
